import { Link } from "react-router-dom";

export default function ButtonGroup() {
  return (
    <>
      <div className="btn-group-wrapper">
        <Link href="#">Join the Beta</Link>
        <Link href="#">Join the Waitlist</Link>
      </div>
    </>
  );
}
